'use client';

import { useTranslations } from 'next-intl';
import { BaseLineRight } from '@/app/components/icons/BaseLineRight';
import { Link } from '@/i18n/routing';

export function PersonalEarningsEntry({ approved }: { approved: boolean }) {
  const t = useTranslations('profile.earnings');

  if (!approved) {
    return null;
  }

  return (
    <section className="mb-5">
      <Link
        href="/profile/earnings"
        prefetch={true}
        className="flex min-w-0 items-center gap-3 rounded-8 border border-system-white/[0.06] bg-system-white/[0.04] px-4 py-3 text-left text-system-white"
      >
        <span className="min-w-0 flex-1 truncate font-medium text-sm leading-5">{t('title')}</span>
        <BaseLineRight className="size-6 shrink-0" />
      </Link>
    </section>
  );
}
